(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-my-size"] && !Shopify.designMode) return;
  try {
    
(() => {
function measure(value){
const text=String(value??'').trim().replace(/[″"']/g,'');
const match=text.match(/^(?:(\d+)\s+)?(\d+)\s*\/\s*(\d+)$/);
if(match)return Number(match[1]||0)+Number(match[2])/Number(match[3]);
return /^\d+(?:\.\d+)?$/.test(text)?Number(text):NaN;
}
function dimensions(p){
const parts=String(p.overall||'').split(/\s*[x×X]\s*/);
const w=parts.length===2?measure(parts[0]):NaN,h=parts.length===2?measure(parts[1]):NaN;
return {...p,w:Number.isFinite(w)?w:measure(p.width),h:Number.isFinite(h)?h:measure(p.height)};
}
function setup(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const form=root.querySelector('form'),status=root.querySelector('[data-status]'),results=root.querySelector('.size-finder__results');
let catalog,request=0;
async function load(){
const firstUrl=new URL(root.dataset.source,location.origin);
async function get(page){
const url=new URL(firstUrl);url.searchParams.set('page',page);
const response=await fetch(url,{headers:{Accept:'text/html'},cache:'no-store'});
if(!response.ok)throw new Error('Catalog request failed');
const data=await response.json();
if(!Array.isArray(data.products)||!Number.isInteger(data.pages))throw new Error('Invalid catalog');
return data;
}
const first=await get(1),all=[...first.products];
for(let page=2;page<=first.pages;page++)all.push(...(await get(page)).products);
return all.filter(p=>p.available).map(dimensions).filter(p=>Number.isFinite(p.w)&&Number.isFinite(p.h)&&p.w>0&&p.h>0);
}
form.addEventListener('submit',async event=>{
event.preventDefault();if(!form.reportValidity())return;
const ticket=++request,values=new FormData(form),width=Number(values.get('width')),height=Number(values.get('height')),wt=Number(values.get('widthTolerance')),ht=Number(values.get('heightTolerance'));
results.replaceChildren();status.textContent=root.dataset.loading;
try{
catalog ||= load().catch(error=>{catalog=null;throw error;});
const products=await catalog;if(ticket!==request)return;
const matches=products.filter(p=>Math.abs(p.w-width)<=wt+1e-8&&Math.abs(p.h-height)<=ht+1e-8).sort((a,b)=>(Math.abs(a.w-width)+Math.abs(a.h-height))-(Math.abs(b.w-width)+Math.abs(b.h-height))||a.title.localeCompare(b.title));
status.textContent=matches.length?root.dataset.count.replace('[count]',matches.length):root.dataset.empty;
const fragment=document.createDocumentFragment();
for(const p of matches){
const card=document.createElement('a');card.className='size-finder__card';card.href=p.url;
if(p.image){const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.width=600;img.height=600;card.append(img);}
const heading=document.createElement('h2');heading.textContent=p.title;
const size=document.createElement('p');size.textContent=p.w+'″ × '+p.h+'″';
const price=document.createElement('p');price.className='size-finder__price';price.textContent=p.price;
const link=document.createElement('span');link.className='size-finder__link';link.textContent=root.dataset.view;
const quantity=document.createElement('p');quantity.className='window-card-quantity';quantity.textContent=root.dataset.quantity.replace('[count]',p.quantity ?? '');
card.append(heading,size);if(p.quantity!==null&&p.quantity!==undefined)card.append(quantity);card.append(price,link);fragment.append(card);
}
results.append(fragment);
}catch(error){if(ticket===request)status.textContent=root.dataset.error;}
});
}
document.querySelectorAll('[data-size-finder]').forEach(setup);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-size-finder]').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
